import { state } from "./state";
import { boardEl, benchEl } from "../dom";
import { flashGain } from "./board";
import { recompute } from "./flow";

/**
 * Tap a hero to pick them up (their pay shows on every contract), tap a
 * contract to post them there. Posting onto an occupied contract benches the
 * previous hero; tapping the selected hero's own contract recalls them.
 * Tapping an occupied contract with no hero selected also recalls — every
 * decision stays reversible.
 */
export function initInteraction(): void {
  benchEl.addEventListener("click", (e) => {
    const card = (e.target as HTMLElement).closest<HTMLElement>(".hero");
    if (!card || state.phase !== "play") return;
    const i = Number(card.dataset.h);
    state.selected = state.selected === i ? -1 : i;
    recompute();
  });

  boardEl.addEventListener("click", (e) => {
    const card = (e.target as HTMLElement).closest<HTMLElement>(".quest");
    if (!card || state.phase !== "play") return;
    const j = Number(card.dataset.q);
    const occupant = state.assign.indexOf(j);

    if (state.selected >= 0) {
      const h = state.selected;
      if (occupant === h) {
        state.assign[h] = -1; // recall the selected hero from their own contract
      } else {
        if (occupant >= 0) state.assign[occupant] = -1; // bench the previous hero
        state.assign[h] = j;
        flashGain(j, state.values()[h][j]);
      }
      state.selected = -1;
      recompute();
      return;
    }

    if (occupant >= 0) {
      state.assign[occupant] = -1;
      recompute();
    }
  });
}
